import { render } from "./programOrganization.vue?vue&type=template&id=b55bcf9c&ts=true"
import script from "./programOrganization.vue?vue&type=script&lang=ts"
export * from "./programOrganization.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\iflam\\OneDrive\\নথিসমূহ\\tms-next\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__